"use client"
import React from "react";

export function isDevelopment() {
    return process.env.NODE_ENV === "development"
}

export function isValidObject<T extends { [key: string|number]: any }>(obj: T, canBeEmpty=false, exceptKeys: any[]=[]): boolean {
    if (obj === null || obj === undefined) return false;
    let hasValid = false;
    for (const key of Object.keys(obj)) {
        if (exceptKeys.includes(key)) continue;
        let v = obj[key]
        if (v !== undefined && v !== null && (!canBeEmpty && v !== ""))hasValid = true;
        if (v) hasValid = true;
    }
    return hasValid;
}

export function DebouncedRefresh(v: any, timerRef: React.RefObject<NodeJS.Timeout|null>, cb: Function, delay = 1000) {
    if (timerRef.current) {
        clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(()=> {
        cb(v)
    }, delay)
}

export function getNowTimeHourMinuteSeconds(): string {
    return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

export type DeviceType = 'web';

export async function getDeviceSafeAreaTop(): Promise<number> {
    return 0;
}

export async function getDeviceType(): Promise<DeviceType> {
    return 'web';
}

export async function getSystemLanguageCode(): Promise<string> {
    try {
        if (typeof navigator !== 'undefined' && navigator.language) {
            return navigator.language || navigator.languages?.[0] || 'en-US';
        }
        return 'en-US';
    } catch (error) {
        console.error('获取系统语言失败:', error);
        return 'en-US';
    }
}
